import { Grid, Card, CardContent, Typography, Link } from '@mui/material';
import { Facebook } from '@mui/icons-material';
import { useMyIntl } from 'my-intl';

import { styles } from './constants';

function Team() {
  const storyMainTextLenght = 200;

  const { translateMessage } = useMyIntl();

  const getStory = (story: string) => {
    if (story?.length > storyMainTextLenght) {
      const mainText = story.substring(0, storyMainTextLenght);
      const moreText = story.substring(storyMainTextLenght + 1);

      return (
        <>
          {mainText}
          <span className="textDots">... </span>
          <span style={{ display: 'none' }}>{moreText} </span>
          <Link href="#" className="link" onClick={readMoreText}>
            {translateMessage('team.readMore')}
          </Link>
        </>
      );
    }

    return story;
  };

  const readMoreText = (ev: React.MouseEvent) => {
    ev.preventDefault();

    const link: HTMLAnchorElement = ev.target as HTMLAnchorElement;
    const dots: HTMLSpanElement = link?.previousElementSibling?.previousElementSibling as HTMLSpanElement;
    const moreText: HTMLSpanElement = link?.previousElementSibling as HTMLSpanElement;

    if (!dots) {
      return;
    }

    if (dots.style.display === 'none') {
      dots.style.display = 'inline';
      link.innerHTML = translateMessage('team.readMore');
      moreText.style.display = 'none';
    } else {
      dots.style.display = 'none';
      link.innerHTML = translateMessage('team.close');
      moreText.style.display = 'inline';
    }
  };

  const hasMessage = (message: string | undefined): boolean => {
    return message?.trim.length !== 0;
  };

  return (
    <Grid container id={styles.ids.team} spacing={2} display={'flex'} justifyContent={'center'} padding={'4rem'}>
      <Grid size={12}>
        <Typography
          component="div"
          variant="h2"
          display={'flex'}
          alignItems={'center'}
          justifyContent={'center'}
          padding={'0 2rem'}
        >
          {translateMessage('team.title')}
        </Typography>
      </Grid>
      <Grid size={4}>
        <Card>
          <CardContent>
            <Typography component="div" display={'flex'} justifyContent={'center'} gutterBottom>
              <img
                src={translateMessage('team.coaches.nina.image')}
                alt={translateMessage('team.coaches.nina.name')}
                className="responsive-img"
                style={{ maxWidth: translateMessage('team.coaches.nina.imageMaxWidth') }}
              />
            </Typography>
            <Typography component="div" variant="h4" display={'flex'} justifyContent={'center'} gutterBottom>
              {translateMessage('team.coaches.nina.name')}
            </Typography>
            <Typography display={'flex'} justifyContent={'center'} gutterBottom>
              <b>{translateMessage('team.coaches.nina.type')}</b>
            </Typography>
            <Typography fontSize={'0.8rem'}>{getStory(translateMessage('team.coaches.nina.story'))}</Typography>
            {hasMessage(translateMessage('team.coaches.nina.facebook')) || (
              <Typography lineHeight={0}>
                <Link href={translateMessage('team.coaches.nina.facebook')} target="_blank">
                  <Facebook />
                </Link>
              </Typography>
            )}
          </CardContent>
        </Card>
      </Grid>
      <Grid size={4}>
        <Card>
          <CardContent>
            <Typography component="div" display={'flex'} justifyContent={'center'} gutterBottom>
              <img
                src={translateMessage('team.coaches.dani.image')}
                alt={translateMessage('team.coaches.dani.name')}
                className="responsive-img"
                style={{ maxWidth: translateMessage('team.coaches.dani.imageMaxWidth') }}
              />
            </Typography>
            <Typography component="div" variant="h4" display={'flex'} justifyContent={'center'} gutterBottom>
              {translateMessage('team.coaches.dani.name')}
            </Typography>
            <Typography display={'flex'} justifyContent={'center'} gutterBottom>
              <b>{translateMessage('team.coaches.dani.type')}</b>
            </Typography>
            <Typography fontSize={'0.8rem'}>{getStory(translateMessage('team.coaches.dani.story'))}</Typography>
            {hasMessage(translateMessage('team.coaches.dani.facebook')) || (
              <Typography lineHeight={0}>
                <Link href={translateMessage('team.coaches.dani.facebook')} target="_blank">
                  <Facebook />
                </Link>
              </Typography>
            )}
          </CardContent>
        </Card>
      </Grid>
      <Grid size={4}>
        <Card>
          <CardContent>
            <Typography component="div" display={'flex'} justifyContent={'center'} gutterBottom>
              <img
                src={translateMessage('team.coaches.eli.image')}
                alt={translateMessage('team.coaches.eli.name')}
                className="responsive-img"
                style={{ maxWidth: translateMessage('team.coaches.eli.imageMaxWidth') }}
              />
            </Typography>
            <Typography component="div" variant="h4" display={'flex'} justifyContent={'center'} gutterBottom>
              {translateMessage('team.coaches.eli.name')}
            </Typography>
            <Typography display={'flex'} justifyContent={'center'} gutterBottom>
              <b>{translateMessage('team.coaches.eli.type')}</b>
            </Typography>
            <Typography fontSize={'0.8rem'}>{getStory(translateMessage('team.coaches.eli.story'))}</Typography>
            {hasMessage(translateMessage('team.coaches.eli.facebook')) || (
              <Typography lineHeight={0}>
                <Link href={translateMessage('team.coaches.eli.facebook')} target="_blank">
                  <Facebook />
                </Link>
              </Typography>
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export default Team;
